import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
//import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { MessageService } from 'primeng/api';
import { PrimeNGConfig } from 'primeng/api';
import { ApiService } from '../../../services/api.service';
import { EditorComponent } from '@tinymce/tinymce-angular';
import { init } from '../../editorconfig';
import { environment } from '../../../../environments/environment';
import { Subscription } from 'rxjs';
import { FileUpload } from 'primeng/fileupload';

@Component({
  selector: 'app-sanction-order',
  standalone: false,
  templateUrl: './sanction-order.component.html',
  styleUrl: './sanction-order.component.scss',
})
export class SanctionOrderComponent  implements OnInit, AfterViewInit, OnDestroy{
  @Output() routeConfig: EventEmitter<any> = new EventEmitter();
  @Input() id: any;
  @Input() getUrl: string;
  @Input() postUrl: string;
  @Output() generatePDFEmitter = new EventEmitter<any>();
  @Output() stepCompleted = new EventEmitter<void>();
  commentForm: FormGroup;
  @Input() step: any;
  @Output() IRA: EventEmitter<any> = new EventEmitter();
  @Input() isEditable: boolean = false;
  @Input() stepDetails: any;
  @Input() schemeType: any;
  isEditorDisabled: boolean = false;
  proposalForm: FormGroup;
  challengeForm: FormGroup;
  init: EditorComponent['init'] = init;
  payload: {
    proposal_id: any;
    // proposal_step:proposalStep,
    proposal_name: any;
  };
  vendorsDoc: any;
  vendorList: any[] = []; // full vendor data list
  section_order: any;
  apiUrl = environment.APIUrl;
  categoryList: string[] = [
    'Technical Evaluation',
    'Financial Evaluation',
    'Commercial Negotiation',
    'Technical Negotiation',
  ];
  private subscriptions = new Subscription();
  userID: any;
     @ViewChild('fileUpload') fileUpload!: FileUpload;
  uploadedUrl: any;
  uploadedFileName: string = '';
  file: File;
  constructor(
    private fb: FormBuilder,
    private config: PrimeNGConfig,
    private messageService: MessageService,
    private api: ApiService,
    private route: ActivatedRoute
  ) {
    this.commentForm = this.fb.group({
      sanction_order: ['', Validators.required],
      cfa_date: [''],
      concurrence_date: [''],
      conclusion_date: [''],
      order_date: [''],
    });
    const role = sessionStorage.getItem('user_role_id');
    this.userID = role;
  }

  ngOnInit(): void {
    this.route.queryParams.subscribe((params: any) => {
      const proposalId = params['id'];
      // const proposalStep = params['step'];
      const proposalName = params['name'];
      this.payload = {
        proposal_id: proposalId,
        // proposal_step:proposalStep,
        proposal_name: proposalName,
      };
    });
    this.getRfpDetails();
  }
  toggleSection(section: string) {
    this.expandedSections[section] = !this.expandedSections[section];
  }
  expandedSections: { [key: string]: boolean } =
  {
    basicInfo: true,
    equipment: false,
    quantity: false,
    cost: false,
    detailedInfo: false,
    uploads: false,
    vendorTable: false
  };
  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }
  goToNextStep() {
    this.stepCompleted.emit();
  }
  ngAfterViewInit() {
    setTimeout(() => {
      if (this.stepDetails?.can_edit) {
        this.isEditorDisabled = false;
        this.commentForm.enable();
      } else {
        this.isEditorDisabled = true;
        this.commentForm.disable();
      }
      this.rebuildEditor();
    }, 3000);
  }
  editorReady = false;
  rebuildEditor() {
    this.editorReady = false; // destroy
    setTimeout(() => {
      this.init = this.getTinyInit(); // refresh config
      this.editorReady = true; // recreate editor
    }, 0);
  }
  getTinyInit(): EditorComponent['init'] {
    return {
      readonly: this.isEditorDisabled,
    };
  }
  getRfpDetails() {
    let vendor_id = sessionStorage.getItem('final_vendor');
    let url;
    if (this.schemeType == 'tdf') {
      url = `/tdf/section-order/?proposal_step=${this.step.id}&proposal_step__proposal=${this.payload.proposal_id}`;
    } else if (this.schemeType == 'makeI') {
      url = `/make1/section-order/?proposal_step=${this.step.id}&proposal_step__proposal=${this.payload.proposal_id}`;
    } else if (this.schemeType == 'makeII' || this.schemeType == 'makeIII') {
      // url = `/make1/make2/section-order/?vendor_id=${vendor_id}&proposal_step=${this.step.id}&proposal_step__proposal=${this.payload.proposal_id}`;
      url = `/make1/make2/section-order/?proposal_step=${this.step.id}&proposal_step__proposal=${this.payload.proposal_id}`;
    } else if (this.schemeType == 'idex') {
      url = `/idex/section-order/?vendor_id=${vendor_id}&proposal_step=${this.step.id}&proposal_step__proposal=${this.payload.proposal_id}`;
    } else {
      url = `/revenue/section-order/?proposal_step=${this.step.id}&proposal_step__proposal=${this.payload.proposal_id}`; // rev url
    }
    const sub = this.api.getAPI(url).subscribe((res: any) => {
      // this.commentForm.disable();
      this.transformGroupedEvaluations(res);
      this.section_order = res;
      console.log("section order",this.section_order);
      this.commentForm.patchValue({
        sanction_order: this.section_order?.draft_sotr || this.section_order.sanction_order.cnc_report || this.section_order?.sanction_order.draft_rfp,
        cfa_date:this.section_order?.sanction_order.cfa_approval,
      concurrence_date: this.section_order?.sanction_order.financial_concurrence,
      conclusion_date:this.section_order.sanction_order.contract_conclusion,
      order_date: this.section_order.sanction_order.sanction_order,
      });
       this.uploadedUrl = res.sanction_order.document || null;
    });
    this.subscriptions.add(sub);
    
  }

  // transformGroupedEvaluations(response: any) {
  //   const vendorsMap = new Map();

  //   const categoryKeyMap = {
  //     'technical_evaluation': 'Technical Evaluation',
  //     'financial_evaluation': 'Financial Evaluation',
  //     'commercial_negotiation': 'Commercial Negotiation',
  //     'technical_negotiation': 'Technical Negotiation'
  //   };

  //   for (const key in response) {
  //     const readableCategory = categoryKeyMap[key];
  //     if (!readableCategory) continue;

  //     response[key].forEach((item: any) => {
  //       const vendorName = item.vendor?.name;
  //       if (!vendorName) return;

  //       if (!vendorsMap.has(vendorName)) {
  //         vendorsMap.set(vendorName, {
  //           name: vendorName,
  //           categories: {}
  //         });
  //       }

  //       const vendor = vendorsMap.get(vendorName);
  //       if (!vendor.categories[readableCategory]) {
  //         vendor.categories[readableCategory] = [];
  //       }

  //       vendor.categories[readableCategory].push(item);
  //     });
  //   }

  //   this.vendorList = Array.from(vendorsMap.values());
  // }

  transformGroupedEvaluations(response: any) {
    const vendorsMap = new Map();

    const categoryKeyMap = {
      technical_evaluation: 'Technical Evaluation',
      financial_evaluation: 'Financial Evaluation',
      commercial_negotiation: 'Commercial Negotiation',
      technical_negotiation: 'Technical Negotiation',
    };

    for (const key in response) {
      // Skip keys that are not in the category map
      if (!categoryKeyMap[key]) continue;

      const readableCategory = categoryKeyMap[key];
      const items = response[key];

      // Only process if it's an array
      if (!Array.isArray(items)) continue;

      items.forEach((item: any) => {
        // Support both formats:
        // - vendor name as `item.vendor?.name`
        // - vendor name as `item.da?.name` (new format)
        const vendorName = item.vendor?.name || item.da?.name;
        if (!vendorName) return;

        if (!vendorsMap.has(vendorName)) {
          vendorsMap.set(vendorName, {
            name: vendorName,
            categories: {},
          });
        }

        const vendor = vendorsMap.get(vendorName);
        if (!vendor.categories[readableCategory]) {
          vendor.categories[readableCategory] = [];
        }

        vendor.categories[readableCategory].push(item);
      });
    }

    this.vendorList = Array.from(vendorsMap.values());
  }

  getCategoryName(key: string): string {
    switch (key) {
      case 'technical_evaluation':
        return 'Technical Evaluation';
      case 'financial_evaluation':
        return 'Financial Evaluation';
      default:
        return key;
    }
  }

  onSubmit(): void {
    let vendor_id = sessionStorage.getItem('final_vendor');
    // if (this.commentForm.valid) {
    const formData = new FormData();
    formData.append('proposal_step', this.id);
    if (this.schemeType == 'makeI' || this.schemeType == 'makeII' || this.schemeType == 'makeIII') {
      formData.append(
        'draft_rfp',
        this.commentForm.get('sanction_order').value
      );
      // formData.append('vendor_id', vendor_id);
    } else if (this.schemeType == 'tdf') {
      // formData.append('vendor', vendor_id);
    } else {
      // formData.append('vendor_id', vendor_id);
    }
    if (this.schemeType == 'rev') {
      formData.append(
        'cnc_report',
        this.commentForm.get('sanction_order').value
      );
      formData.append(
        'financial_concurrence',
        this.commentForm.get('concurrence_date').value
      );
      formData.append('cfa_approval', this.commentForm.get('cfa_date').value);
      formData.append(
        'sanction_order',
        this.commentForm.get('order_date').value
      );
      formData.append(
        'contract_conclusion',
        this.commentForm.get('conclusion_date').value
      );
    } else {
      formData.append(
        'draft_rfp',
        this.commentForm.get('sanction_order').value
      );
    }

    if (
      this.schemeType == 'makeI' ||
      this.schemeType == 'makeII' ||
      this.schemeType == 'makeIII'
    ) {
      if (this.section_order?.sanction_order.id) {
        const sub = this.api
          .putAPI(`/make1/section-order/${this.section_order.sanction_order.id}/`, formData)
          .subscribe((res: any) => {
            // console.log(res);
            this.getRfpDetails();
            this.messageService.add({
              severity: 'success',
              summary: 'Success',
              detail: res.message || 'Data updated successfully',
            });
             this.uploadedUrl = null;
        this.uploadedFileName = ''
          });
        this.subscriptions.add(sub);
      } else {
        const sub = this.api
          .postAPI('/make1/section-order/', formData)
          .subscribe((res: any) => {
            this.getRfpDetails();
            this.messageService.add({
              severity: 'success',
              summary: 'Success',
              detail: res.message || 'Order uploaded successfully',
            });
             this.uploadedUrl = null;
        this.uploadedFileName = ''
          });
        this.subscriptions.add(sub);
      }
    } else if (this.schemeType == 'tdf') {
      if (this.section_order?.sanction_order.id) {
        const sub = this.api
          .putAPI(`/tdf/section-order/${this.section_order.sanction_order.id}/`, formData)
          .subscribe((res: any) => {
            // console.log(res);
            this.getRfpDetails();
            this.messageService.add({
              severity: 'success',
              summary: 'Success',
              detail: res.message || 'Data updated successfully',
            });
          });
        this.subscriptions.add(sub);
      } else {
        const sub = this.api
          .postAPI('/tdf/section-order/', formData)
          .subscribe((res: any) => {
            this.getRfpDetails();
            this.messageService.add({
              severity: 'success',
              summary: 'Success',
              detail: res.message || 'Data uploaded successfully',
            });
          });
        this.subscriptions.add(sub);
      }
    } else {
      let url;
      if (this.schemeType == 'idex') {
        url = `/idex/section-order/`;
      } else {
        url = `/revenue/section-order/`;
      }
      if (this.section_order) {
        const sub = this.api
          .putAPI(url + `${this.section_order?.sanction_order.id}/`, formData)
          .subscribe((res: any) => {
            // console.log(res);
            this.getRfpDetails();
            this.messageService.add({
              severity: 'success',
              summary: 'Success',
              detail: res.message || 'Order updated successfully',
            });
          });
        this.subscriptions.add(sub);
      } else {
        const sub = this.api.postAPI(url, formData).subscribe((res: any) => {
          this.getRfpDetails();
          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: res.message || 'Order uploaded successfully',
          });
          
        });
        this.subscriptions.add(sub);
      }
    }
  }
  generatePDF() {
    const payload = {
      url: '/revenue/need/version-control/',
      data: [
        { key: 'Proposal Name', value: this.payload.proposal_name },
        {
          key: 'Sanction order',
          value: this.commentForm.get('sanction_order')?.value,
        },
      ],
    };
    this.generatePDFEmitter.emit(payload);
  }
    clearUpload(fileUpload: any) {
    this.uploadedFileName = null;
    // this.uploadedUrl = null;
    fileUpload.clear();
  }
   onUpload(event: any): void {
    const file = event.files?.[0];
    this.uploadedFileName = file.name;
    this.file = file;
  }
    getFileName(url: string): string {
    const fileName = url?.split('/').pop() || 'Unknown File';
    return fileName.length > 50 ? fileName.substring(0, 50) + '...' : fileName;
  }
}
